import tracking from "../../utils/tracking";

// Map Structures
const journeyStepsMap = {
  0: "component--download-journey-stage1",
  1: "component--download-journey-stage2",
  2: "component--download-journey-stage3",
  3: "component--download-journey-stage4",
  4: "component--download-journey-stage5",
};

const osSpecificTriggerBannerIdMap = {
  operating_system_step_4: "operating_system_step_4",
  operating_system_step_5: "operating_system_step_5",
  operating_system: "operating_system",
};

const cloudServiceProviderTriggerIdMap = {
  cloud_platform: "cloud_platform",
  cloud_platform_step_4: "cloud_platform_step_4",
};

const softwareVersion = {
  longTermSupport: "Enterprise",
  latestRelease: "Standard",
};

const triggerValue = {
  long_term_support: "long_term_support",
  latest_release: "latest_release",
};

const downloadJsonMap = { Standard: {}, Enterprise: {} };

const latestVersionsByType = {
  Enterprise: "",
  Standard: "",
  Latest: {
    type: "",
    version: "",
  },
  Last: {
    type: "",
    version: "",
  },
};

const urlLinkMap = {
  osx: "",
  linux_64_bit: "",
  tar_gz_archive: "",
  windows_64_bit: "",
  zip_archive: "",
};

class DownloadJourneyContainer {
  domRoot: HTMLElement;
  params: any;
  numOfSteps: number;
  currentStage: number;
  previousStage: number;
  backButton: any;
  nextButton: any;
  checksum: any;
  licenseAgreementAndPrivacyPolicyCheckbox: any;
  bannerContainer: any;
  listOfInputButtons: NodeListOf<Element>;
  listOfVersionChoicesId: string[];
  displayBannerShown: boolean;
  isReadyToBeCompleted: boolean;
  isLoading: boolean;
  downloadJson: never[];
  downloadJsonMap: { Standard: {}; Enterprise: {} };
  downloadItems: never[];
  downloadUrlLinks: {
    osx: string;
    linux_64_bit: string;
    tar_gz_archive: string;
    windows_64_bit: string;
    zip_archive: string;
  };
  softwareVersionSelected: string;
  latestVersionsByType: {
    Enterprise: string;
    Standard: string;
    Latest: { type: string; version: string };
    Last: { type: string; version: string };
  };
  nextStep: string;
  optionsIncludingKubernete: string[];
  isServerSelected: boolean;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.numOfSteps = 5;
    this.currentStage = 0;
    this.previousStage = 0;
    this.backButton = document.querySelector('a[data-label="Back"]');
    this.nextButton = document.querySelector('a[data-label="Next"]');
    this.checksum = document.querySelector('#checksum-download a');
    this.licenseAgreementAndPrivacyPolicyCheckbox = document.querySelector(
      "#license-agreement-and-privacy-policy"
    );
    this.bannerContainer = document.querySelector(
      ".container--announcement-banner-container"
    );
    this.listOfInputButtons = document.querySelectorAll(
      ".component--download-journey-container input"
    );
    this.listOfVersionChoicesId = [
      "choose_your_version",
      "choose_your_version_step_4",
    ];
    this.displayBannerShown = false;
    this.isReadyToBeCompleted = false;
    this.isLoading = false;
    this.downloadJson = [];
    this.downloadJsonMap = downloadJsonMap;
    this.downloadItems = [];
    this.downloadUrlLinks = urlLinkMap;
    this.softwareVersionSelected = softwareVersion.latestRelease;
    this.latestVersionsByType = latestVersionsByType;
    this.nextStep = "";
    this.optionsIncludingKubernete = [
      "choose_your_infrastructure",
      "choose_your_infrastructure_step_3",
    ];
    this.isServerSelected = false;
    this.init();
  }

  init() {
    var self = this;
    self.isLoading = true;

    self.getJSON(self.params.productArchivedJSON);
    self.getJSON(self.params.productCurrentJSON);

    self.nextButton.addEventListener("click", (e) => {
      e.preventDefault();

      if (self.isReadyToBeCompleted) {
        window.location = self.nextButton.href;
      } else if (
        self.numOfSteps >= self.currentStage + 1 &&
        !self.nextButton.classList.contains("isdisabled")
      ) {
        // don't do anything if nothing in current step is selected
        const selectedInput = document.querySelector(
          `#${journeyStepsMap[self.currentStage]} input:checked`
        );

        if (selectedInput) {
          self.nextStep = selectedInput.getAttribute("data-next-step");
          const selectedInputVallue = selectedInput.value;
          const currentStep = selectedInput.getAttribute("name");
          if (currentStep === "choose_your_deployment") {
            self.isServerSelected = selectedInputVallue === "server";
          }
          self.setVersionNumberOnText(self.nextStep);

          // if it is crowd always ues the 'latest release', since lts/enterprise doesn't exist
          if (
            (self.params.product === "crowd" &&
              osSpecificTriggerBannerIdMap[self.nextStep]) ||
            self.nextStep === "operating_system"
          ) {
            self.parseAndSetUrlPerVersionTypeSelection(
              triggerValue.latest_release
            );
          } else {
            self.parseAndSetUrlPerVersionTypeSelection(selectedInputVallue);
          }

          if (self.nextStep) {
            document.querySelector(`#${self.nextStep}`).style.display = "block";
            self.previousStage = self.currentStage;
            self.currentStage = self.currentStage + 1;

            document.querySelector(
              `#${journeyStepsMap[self.currentStage]}`
            ).style.display = "block";

            self.isToDisableNextButton(self.nextStep);
            self.isNextStageOSRelatedNextStage(self.nextStep);
            self.isCloudPlatformRelatedNextStage(self.nextStep);

            self.isDisabledOrEnableInputs(journeyStepsMap[self.previousStage]);
          }
        }
      }
    });

    self.backButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (self.currentStage > 0) {
        const currentStage = journeyStepsMap[self.currentStage];

        // clean up currentStep
        const listOfFieldSetsUnderCurrentStep = document.querySelectorAll(
          `#${currentStage} fieldset`
        );
        const listOfFieldSetsUnderCurrentStepChildernInputs =
          document.querySelectorAll(`#${currentStage} fieldset input`);
        listOfFieldSetsUnderCurrentStepChildernInputs.forEach(
          (inputElement) => (inputElement.checked = false)
        );
        listOfFieldSetsUnderCurrentStep.forEach(
          (element) => (element.style.display = "none")
        );
        document.querySelector(`#${currentStage}`).style.display = "none";
        if (self.displayBannerShown) {
          self.bannerContainer.style.display = "none";
        }
        self.nextButton.innerText = self.params.buttonText.nextButtonText;

        self.currentStage = self.previousStage;
        self.previousStage = self.previousStage - 1;
        self.nextStep = "";

        const selectedInput = document.querySelector(
          `#${journeyStepsMap[self.currentStage]} input:checked`
        );
        if (selectedInput) {
          const currentStep = selectedInput.getAttribute("name");
          if (currentStep === "choose_your_deployment") {
            self.isServerSelected = false;
          }
        }
      }

      if (self.nextButton.classList.contains("isdisabled")) {
        self.nextButton.classList.remove("isdisabled");
        self.checksum.classList.remove("disabled");
      }

      self.licenseAgreementAndPrivacyPolicyCheckbox.checked = false;
      self.isReadyToBeCompleted = false;

      self.isDisabledOrEnableInputs(journeyStepsMap[self.currentStage], false);
    });

    self.licenseAgreementAndPrivacyPolicyCheckbox.addEventListener(
      "change",
      () => {
        const isRequiredFieldChecked = self.isOSVersionFieldChecked();
        const isNextButtonContainClassIsdisabled =
          self.nextButton.classList.contains("isdisabled");
        if (
          self.licenseAgreementAndPrivacyPolicyCheckbox.checked &&
          isNextButtonContainClassIsdisabled &&
          isRequiredFieldChecked &&
          !self.isLoading
        ) {
          self.nextButton.classList.remove("isdisabled");
          self.checksum.classList.remove("disabled");
          self.isReadyToBeCompleted = true;
        } else {
          !isNextButtonContainClassIsdisabled &&
            self.nextButton.classList.add("isdisabled");
            self.checksum.classList.add("disabled");
          self.isReadyToBeCompleted = false;
        }
      }
    );

    self.listOfInputButtons.forEach((inputElement) =>
      inputElement.addEventListener("click", () => {
        tracking.trackEvent("clicked", { ...inputElement.dataset });
      })
    );

    self.isAttachedEventListenersToInputButtons(
      osSpecificTriggerBannerIdMap,
      true
    );
    self.isAttachedEventListenersToInputButtons(
      cloudServiceProviderTriggerIdMap
    );
    self.isAttachedEventListenersToDifferSetsOfInputButtons(
      self.optionsIncludingKubernete
    );
  }

  isNextStageOSRelatedNextStage(nextStep) {
    if (nextStep === osSpecificTriggerBannerIdMap[nextStep]) {
      this.bannerContainer.style.display = "block";
      this.displayBannerShown = true;
      this.nextButton.innerText = this.params.buttonText.downloadText;
    }
  }

  isOSVersionFieldChecked() {
    let isChecked = false;
    Object.keys(osSpecificTriggerBannerIdMap).forEach((fieldsetId) => {
      const listOfInputFields = document.querySelectorAll(
        `#${fieldsetId} input`
      );
      for (let nodeItem of listOfInputFields) {
        if (nodeItem.checked) {
          isChecked = true;
          break;
        }
      }
    });
    return isChecked;
  }

  isCloudPlatformRelatedNextStage(nextStep) {
    if (nextStep === cloudServiceProviderTriggerIdMap[nextStep]) {
      this.nextButton.innerText = this.params.buttonText.getStartedText;
    }
  }

  isToDisableNextButton(nextStep) {
    let isInTriggerList = false;
    const updatedTriggerList = {
      ...osSpecificTriggerBannerIdMap,
      ...cloudServiceProviderTriggerIdMap,
    };
    if (nextStep === updatedTriggerList[nextStep]) {
      isInTriggerList = true;
    }

    if (isInTriggerList) {
      !this.nextButton.classList.contains("isdisabled") &&
        this.nextButton.classList.add("isdisabled");
    }
  }

  isAttachedEventListenersToInputButtons(
    idMap,
    isBannerContainerInvolved = false
  ) {
    var self = this;
    Object.keys(idMap).forEach((osFieldsetId) => {
      const listOfInputFields = document.querySelectorAll(
        `#${osFieldsetId} input`
      );
      listOfInputFields.forEach((inputElement) => {
        inputElement.addEventListener("click", (event) =>
          self.setNextUrlClickEvent(event, isBannerContainerInvolved)
        );
      });
    });
  }

  isAttachedEventListenersToDifferSetsOfInputButtons(listOfIds) {
    var self = this;
    listOfIds.forEach((inputFieldsSelector) => {
      const listOfInputFields = document.querySelectorAll(
        `#${inputFieldsSelector} input`
      );
      listOfInputFields.forEach((inputElement) => {
        inputElement.addEventListener("click", (event) => {
          if (event.target.dataset.label === "kubernetes") {
            self.nextButton.innerText = self.params.buttonText.getStartedText;
          } else {
            self.nextButton.innerText = self.params.buttonText.nextButtonText;
          }
          self.setNextUrlClickEvent(event, false);
        });
      });
    });
  }

  setNextUrlClickEvent(event, isBannerContainerInvolved) {
    const urlAttr = event.target.getAttribute("data-next-url");
    if (urlAttr) {
      this.nextButton.href = urlAttr;
      this.checksum.href = urlAttr + '.sha256';

      this.isReadyToBeCompleted = isBannerContainerInvolved
        ? this.licenseAgreementAndPrivacyPolicyCheckbox.checked
        : true;

      if (
        this.isReadyToBeCompleted &&
        this.nextButton.classList.contains("isdisabled") &&
        !this.isLoading
      ) {
        this.nextButton.classList.remove("isdisabled");
        this.checksum.classList.remove("disabled");
      }
    } else {
      this.nextButton.href = "";
      this.checksum.href = "";
      this.isReadyToBeCompleted = false;
    }
  }

  async getJSON(url: string) {
    const newData = await fetch(url,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      })
      .then((res) => res.json())
      .catch();
    if (newData) {
      var oldData = this.downloadJson;
      var joinedData = oldData.concat(newData);
      this.downloadJson = joinedData;

      this.formatDownloads();
    }
  }

  formatDownloads() {
    this.downloadJsonMap = downloadJsonMap;
    this.createDownloadJsonMap(this.downloadJson);

    this.latestVersionsByType.Enterprise = this.getTheHighestVersionNumber(
      softwareVersion.longTermSupport
    );
    this.latestVersionsByType.Standard = this.getTheHighestVersionNumber(
      softwareVersion.latestRelease
    );

    // GWP-1004 : Server end of support for bitbucket, jira-software, and crowd

    if (this.params.product === "stash") {
      const lastServerVersion = "8.15.0";
      const allLatest = this.getOrderedVersionNumbers(
        softwareVersion.latestRelease
      );
      const lastVersion = allLatest.filter((i) =>
        this.isGreater(lastServerVersion, i)
      )[0];
      this.latestVersionsByType.Last = {
        type: softwareVersion.latestRelease,
        version: lastVersion,
      };
    } else if (this.params.product === "crowd") {
      const lastServerVersion = "5.3.0";
      const allLatest = this.getOrderedVersionNumbers(
        softwareVersion.latestRelease
      );
      const lastVersion = allLatest.filter((i) =>
        this.isGreater(lastServerVersion, i)
      )[0];
      this.latestVersionsByType.Last = {
        type: softwareVersion.latestRelease,
        version: lastVersion,
      };
    } else if (this.params.product === "jira-software") {
      const lastServerVersion = "9.13.0";
      const allLatest = this.getOrderedVersionNumbers(
        softwareVersion.longTermSupport
      );
      const lastVersion = allLatest.filter((i) =>
        this.isGreater(lastServerVersion, i)
      )[0];
      this.latestVersionsByType.Last = {
        type: softwareVersion.longTermSupport,
        version: lastVersion,
      };
    } else if (this.params.product === "jira-servicedesk") {
      const lastServerVersion = "5.13.0";
      const allLatest = this.getOrderedVersionNumbers(
        softwareVersion.longTermSupport
      );
      const lastVersion = allLatest.filter((i) =>
        this.isGreater(lastServerVersion, i)
      )[0];
      this.latestVersionsByType.Last = {
        type: softwareVersion.longTermSupport,
        version: lastVersion,
      };
    }

    // if we are on the confluence page, ensure the latest version(s) are pre-DC-only
    if (this.params.product === "confluence") {
      const confluenceDcOnlyStartingVersion = "8.6.0";

      const allLts = this.getOrderedVersionNumbers(
        softwareVersion.longTermSupport
      );
      const allLatest = this.getOrderedVersionNumbers(
        softwareVersion.latestRelease
      );

      this.latestVersionsByType.Enterprise = allLts.filter((i) =>
        this.isGreater(confluenceDcOnlyStartingVersion, i)
      )[0];
      this.latestVersionsByType.Standard = allLatest.filter((i) =>
        this.isGreater(confluenceDcOnlyStartingVersion, i)
      )[0];
    }

    // default latest type is standard
    const { Standard, Enterprise } = this.latestVersionsByType;
    this.latestVersionsByType.Latest.type = softwareVersion.latestRelease;
    this.latestVersionsByType.Latest.version = Standard;

    if (Standard && Enterprise) {
      const isStandardGreaterThanEnterprise = this.isGreater(
        Standard,
        Enterprise
      );
      if (!isStandardGreaterThanEnterprise) {
        this.latestVersionsByType.Latest.type = softwareVersion.longTermSupport;
        this.latestVersionsByType.Latest.version = Enterprise;
      }
    } else if (Enterprise) {
      /**
       * If we get here then that means Standard is null, undefined, or empty string
       */
      this.latestVersionsByType.Latest.type = softwareVersion.longTermSupport;
      this.latestVersionsByType.Latest.version = Enterprise;
    }

    this.isLoading = false;
  }

  setDownloadUrlLinks() {
    let highestVersionNumberPerSelection =
      this.latestVersionsByType[this.softwareVersionSelected];
    let listOFDownloadsMap =
      this.downloadJsonMap[this.softwareVersionSelected][
        highestVersionNumberPerSelection
      ];

    if (
      this.isServerSelected &&
      this.softwareVersionSelected === this.latestVersionsByType.Last.type
    ) {
      listOFDownloadsMap =
        this.downloadJsonMap[this.latestVersionsByType.Last.type][
          this.latestVersionsByType.Last.version
        ];
    }
    // if we want the latest release, always return latest release regardless if it is Standard or Enterprise
    else if (this.softwareVersionSelected === softwareVersion.latestRelease) {
      listOFDownloadsMap =
        this.downloadJsonMap[this.latestVersionsByType.Latest.type][
          this.latestVersionsByType.Latest.version
        ];
    }

    // pre-clear the map
    for (let key in this.downloadUrlLinks) {
      this.downloadUrlLinks[key] = "";
    }

    const versionJsonMap = Object.entries(listOFDownloadsMap).map(
      (item) => item[1]
    );
    versionJsonMap.forEach((mappingIndex) => {
      const downloadLinkObject = this.downloadJson[mappingIndex];
      if (downloadLinkObject.description.includes("Windows")) {
        this.downloadUrlLinks.windows_64_bit = downloadLinkObject.zipURL;
      } else if (downloadLinkObject.description.includes("Linux")) {
        this.downloadUrlLinks.linux_64_bit = downloadLinkObject.zipURL;
      } else if (downloadLinkObject.description.includes("TAR.GZ")) {
        this.downloadUrlLinks.tar_gz_archive = downloadLinkObject.zipURL;
        this.downloadUrlLinks.osx = downloadLinkObject.zipURL;
      } else if (downloadLinkObject.description.includes("ZIP")) {
        this.downloadUrlLinks.zip_archive = downloadLinkObject.zipURL;
      }
    });
  }

  createDownloadJsonMap(downloadJson) {
    return downloadJson.forEach((item, index) => {
      // doing this just in case the edition comes back as 'None'
      item.platform = item.downloadLabels.map((label: any) => label.labelName);
      item.description = item.name;
      item.downloadLink = item.zipURL;
      const jsonMapWithEdition = this.downloadJsonMap[item.edition]
        ? this.downloadJsonMap[item.edition]
        : this.downloadJsonMap[softwareVersion.latestRelease];

      if (jsonMapWithEdition[item.version.name]) {
        if (!jsonMapWithEdition[item.version.name][item.name]) {
          jsonMapWithEdition[item.version.name][item.name] = index;
        }
      } else {
        jsonMapWithEdition[item.version.name] = {};
        jsonMapWithEdition[item.version.name][item.name] = index;
      }
    });
  }

  getOrderedVersionNumbers(softwareVersionSelected) {
    const downloadJsonMapKeys = Object.keys(
      this.downloadJsonMap[softwareVersionSelected]
    );
    return downloadJsonMapKeys
      .map((a) =>
        a
          .split(".")
          .map((n) => +n + 100000)
          .join(".")
      )
      .sort()
      .reverse()
      .map((a) =>
        a
          .split(".")
          .map((n) => +n - 100000)
          .join(".")
      );
  }

  getTheHighestVersionNumber(softwareVersionSelected) {
    return this.getOrderedVersionNumbers(softwareVersionSelected)[0];
  }

  setInputDataNextUrl() {
    Object.keys(this.downloadUrlLinks).forEach((key) => {
      const inputElement = document.querySelector(
        `#${this.nextStep} input[value="${key}"]`
      );
      if (inputElement && this.downloadUrlLinks[key] != "") {
        inputElement.parentNode.style.display = "block";
        inputElement.dataset.nextUrl = this.downloadUrlLinks[key];
      } else if (inputElement) {
        inputElement.parentNode.style.display = "none";
      }
    });
  }

  setVersionNumberOnText(nextStep) {
    if (this.listOfVersionChoicesId.includes(nextStep)) {
      const currentLTSVersionValue = document.querySelector(
        `#${nextStep} span#lts_text`
      );
      const currentLatestVersionValue = document.querySelector(
        `#${nextStep} span#latest_text`
      );
      const currentLastVersionValue = document.querySelector(
        `#${nextStep} span#last_text`
      );
      if (currentLTSVersionValue) {
        currentLTSVersionValue.innerText =
          this.isServerSelected &&
          this.latestVersionsByType.Last.type ===
            softwareVersion.longTermSupport
            ? currentLTSVersionValue.innerText.replace(
                /.*/,
                `(${this.latestVersionsByType.Last.version})`
              )
            : currentLTSVersionValue.innerText.replace(
                /.*/,
                `(${this.latestVersionsByType.Enterprise})`
              );
      }
      if (currentLatestVersionValue) {
        currentLatestVersionValue.innerText =
          this.isServerSelected &&
          this.latestVersionsByType.Last.type === softwareVersion.latestRelease
            ? currentLatestVersionValue.innerText.replace(
                /.*/,
                `(${this.latestVersionsByType.Last.version})`
              )
            : currentLatestVersionValue.innerText.replace(
                /.*/,
                `(${this.latestVersionsByType.Latest.version})`
              );
      }
      if (currentLastVersionValue) {
        currentLastVersionValue.innerText =
          currentLastVersionValue.innerText.replace(
            /.*/,
            `(${this.latestVersionsByType.Last.version})`
          );
      }
    }
  }

  parseAndSetUrlPerVersionTypeSelection(selectedInputVallue) {
    if (selectedInputVallue === triggerValue[selectedInputVallue]) {
      this.softwareVersionSelected =
        selectedInputVallue === triggerValue.long_term_support
          ? softwareVersion.longTermSupport
          : softwareVersion.latestRelease;
      this.setDownloadUrlLinks();
      this.setInputDataNextUrl();
    }
  }

  isDisabledOrEnableInputs(element, isDisabled = true) {
    document
      .querySelectorAll(`#${element} input`)
      .forEach((inputElement) => (inputElement.disabled = isDisabled));
  }

  isGreater(primaryVersion, secondaryVersion) {
    return (
      primaryVersion.localeCompare(secondaryVersion, undefined, {
        numeric: true,
      }) === 1
    );
  }
}

export default DownloadJourneyContainer;
